// Shown when the Hub rejects a submission's captcha token (AP-11102).
export const CAPTCHA_COPY = {
  retry: "We couldn't confirm you're not a bot. Please try again in a moment.",
} as const
